import React from 'react'
import { FlowGrid } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { trackEvent } from '@fs/zion-analytics'
import TakeAwayImage from '../TakeAwayImage/TakeAwayImage'

export default function TakeAwayList({ toggleDrawer, dialogOpener, setSelected, takeAwayListData }) {
  const takeAwayItemCSS = css`
    width: 160px;
    height: 160px;
    margin: 20px;
  `

  const takeAwayListContainerCSS = css`
    margin: 20px;
    flex-grow: 1;
    overflow: auto;
  `

  const takeAwayImageCss = css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  `

  const viewTakeAway = (takeAway) => {
    toggleDrawer()
    setSelected(takeAway)
    trackEvent({ event_name: 'TakeAwaysList:VIEW_TAKEAWAY:CLICK', takeAway })
    dialogOpener.open()
  }

  return (
    <div css={takeAwayListContainerCSS} data-testid="take-aways-list">
      <FlowGrid columnCount={2}>
        {takeAwayListData?.map((takeAway) => {
          return (
            takeAway?.type !== 'video' && (
              <div key={takeAway?.fileName}>
                <div
                  data-testid="take-away-list"
                  onKeyPress={() => {
                    viewTakeAway(takeAway)
                  }}
                  role="button"
                  onClick={() => {
                    viewTakeAway(takeAway)
                  }}
                  css={takeAwayItemCSS}
                  tabIndex={0}
                >
                  <TakeAwayImage takeAway={takeAway} css={takeAwayImageCss} style={{ width: '160px' }} />
                </div>
              </div>
            )
          )
        })}
      </FlowGrid>
    </div>
  )
}
